import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import axios from 'axios';
import { i18n } from '../../translate/i18n';
import { fetchEquipmentsService } from '../../services/equipments';
let CancelToken = axios.CancelToken;
let fetchServices_cancel;
let fetchServicesById_cancel;
let fetchServicesByEquipment_cancel;
let fetchServicesExport_cancel;

export const setServicesFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_SERVICES_FILTER,
    servicesFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const setServicesSelected = (selected = []) => {
  return {
    type: actionTypes.SET_SERVICES_SELECTED,
    servicesSelected: selected,
  };
};

export const clearServicesSelected = () => {
  return {
    type: actionTypes.CLEAR_SERVICES_SELECTED,
    servicesSelected: [],
  };
};

export const filterServiceServiceTypes = (serviceTypes) => {
  return {
    type: actionTypes.FILTER_SERVICE_SERVICE_TYPES,
    serviceTypes,
  };
};

export const filterServiceServiceTypesRemove = (serviceType) => {
  return {
    type: actionTypes.FILTER_SERVICE_SERVICE_TYPES_REMOVE,
    serviceType,
  };
};

export const filterServiceFrequencies = (frequencies) => {
  return {
    type: actionTypes.FILTER_SERVICE_FREQUENCIES,
    frequencies,
  };
};

export const filterServiceFrequenciesRemove = (frequency) => {
  return {
    type: actionTypes.FILTER_SERVICE_FREQUENCIES_REMOVE,
    frequency,
  };
};

export const filterServiceUsers = (users) => {
  return {
    type: actionTypes.FILTER_SERVICE_USERS,
    users,
  };
};

export const filterServiceUsersRemove = (user) => {
  return {
    type: actionTypes.FILTER_SERVICE_USERS_REMOVE,
    user,
  };
};

export const filterServicePlaces = (places) => {
  return {
    type: actionTypes.FILTER_SERVICE_PLACES,
    places,
  };
};

export const filterServicePlacesRemove = (place) => {
  return {
    type: actionTypes.FILTER_SERVICE_PLACES_REMOVE,
    place,
  };
};

export const filterServiceCompanies = (companies) => {
  return {
    type: actionTypes.FILTER_SERVICE_COMPANIES,
    companies,
  };
};

export const filterServiceCompaniesRemove = (companies) => {
  return {
    type: actionTypes.FILTER_SERVICE_COMPANIES_REMOVE,
    companies,
  };
};

export const filterServiceAreas = (areas) => {
  return {
    type: actionTypes.FILTER_SERVICE_AREAS,
    areas,
  };
};

export const filterServiceAreasRemove = (area) => {
  return {
    type: actionTypes.FILTER_SERVICE_AREAS_REMOVE,
    area,
  };
};

export const filterServiceModels = (models) => {
  return {
    type: actionTypes.FILTER_SERVICE_MODELS,
    models,
  };
};

export const filterServiceModelsRemove = (model) => {
  return {
    type: actionTypes.FILTER_SERVICE_MODELS_REMOVE,
    model,
  };
};

export const filterServiceGroups = (groups) => {
  return {
    type: actionTypes.FILTER_SERVICE_GROUPS,
    groups,
  };
};

export const filterServiceGroupsRemove = (group) => {
  return {
    type: actionTypes.FILTER_SERVICE_GROUPS_REMOVE,
    group,
  };
};

export const filterServiceStartDate = (startDate) => {
  return {
    type: actionTypes.FILTER_SERVICE_START_DATE,
    startDate,
  };
};

export const filterServiceStartDateRemove = (startDate) => {
  return {
    type: actionTypes.FILTER_SERVICE_START_DATE_REMOVE,
    startDate,
  };
};

export const filterServiceEndDate = (endDate) => {
  return {
    type: actionTypes.FILTER_SERVICE_END_DATE,
    endDate,
  };
};

export const filterServiceEndDateRemove = (endDate) => {
  return {
    type: actionTypes.FILTER_SERVICE_END_DATE_REMOVE,
    endDate,
  };
};

export const filterServiceSources = (sources) => {
  return {
    type: actionTypes.FILTER_SERVICE_SOURCES,
    sources,
  };
};

export const filterServiceDoneInDelay = (doneInDelay) => {
  return {
    type: actionTypes.FILTER_SERVICE_DONE_IN_DELAY,
    doneInDelay,
  };
};

export const filterServiceClear = (model) => {
  return {
    type: actionTypes.FILTER_SERVICE_CLEAR,
    model,
  };
};

export const fetchServicesSuccess = (services) => {
  return {
    type: actionTypes.FETCH_SERVICES_SUCCESS,
    services: services
  };
};

export const fetchServicesByEquipmentSuccess = (services) => {
  return {
    type: actionTypes.FETCH_SERVICES_BY_EQUIPMENT_SUCCESS,
    services: services
  };
};

export const fetchCompanyByIdSuccess = (service) => {
  return {
    type: actionTypes.FETCH_SERVICES_BY_ID_SUCCESS,
    service: service
  };
}

export const requestServicesFail = (error) => {
  return {
    type: actionTypes.REQUEST_SERVICES_FAIL,
    error: error
  };
};

export const requestServicesStart = () => {
  return {
    type: actionTypes.REQUEST_SERVICES_START
  };
};

export const deleteServicesSuccess = (service) => {
  return {
    type: actionTypes.DELETE_SERVICES_SUCCESS,
    service: service
  }
}

export const checkDeleteDocumentServicesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_SERVICES_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateServicesSuccess = (service) => {
  return {
    type: actionTypes.UPDATE_SERVICES_SUCCESS,
    service: service
  }
}

export const postServicesSuccess = (service) => {
  return {
    type: actionTypes.POST_SERVICES_SUCCESS,
    service: service
  }
}

export const fetchServices = (page, limit, search, order, orderBy, sites, filteredPlaces, filteredAreas, filteredCompanies,filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredDoneInDelay) => {
  fetchServices_cancel && fetchServices_cancel()

  return dispatch => {
    dispatch(requestServicesStart());
    dispatch(setServicesFilter(page, limit, search, order, orderBy));
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `&${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
    queryParams += `${filteredModels && filteredModels.length > 0 ? '&models=' + filterObjectToQuery(filteredModels) : ''}`
    queryParams += `${filteredGroups && filteredGroups.length > 0 ? '&groups=' + filterObjectToQuery(filteredGroups) : ''}`
    queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
    queryParams += `${filteredAreas && filteredAreas.length > 0 ? '&areas=' + filterObjectToQuery(filteredAreas) : ''}`
    queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? '&companies=' + filterObjectToQuery(filteredCompanies) : ''}`
    queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&service_types=' + filterObjectToQuery(filteredServiceTypes) : ''}`
    queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
    queryParams += `${filteredUsers && filteredUsers.length > 0 ? '&users=' + filterObjectToQuery(filteredUsers) : ''}`
    queryParams += `${filteredEquipment ? '&equipments=' + filteredEquipment.value : ''}`
    queryParams += `${filteredStartDate ? `&after=${filteredStartDate.toISOString()}` : ''}`
    queryParams += `${filteredEndDate ? `&before=${filteredEndDate.toISOString()}` : ''}`
    queryParams += `${filteredSources && filteredSources.length > 0 ? '&sources=' + filterObjectToQuery(filteredSources) : ''}`
    queryParams += `${filteredDoneInDelay ? '&doneInDelay=true' : ''}`

    API.get('/services' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchServices_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchServicesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestServicesFail(err));
      });
  };
};

export const fetchServicesExport = (search, order, orderBy, sites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredDoneInDelay, emailLanguage) => {
  fetchServicesExport_cancel && fetchServicesExport_cancel()
  return dispatch => {
    return new Promise((resolve, reject) => {
			let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
			queryParams += `&${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
			queryParams += `${filteredModels && filteredModels.length > 0 ? '&models=' + filterObjectToQuery(filteredModels) : ''}`
      queryParams += `${filteredGroups && filteredGroups.length > 0 ? '&groups=' + filterObjectToQuery(filteredGroups) : ''}`
			queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
			queryParams += `${filteredAreas && filteredAreas.length > 0 ? '&areas=' + filterObjectToQuery(filteredAreas) : ''}`
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? '&companies=' + filterObjectToQuery(filteredCompanies) : ''}`
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&service_types=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? '&users=' + filterObjectToQuery(filteredUsers) : ''}`
      queryParams += `${filteredEquipment ? '&equipments=' + filteredEquipment.value : ''}`
			queryParams += `${filteredStartDate ? `&after=${filteredStartDate.toISOString()}` : ''}`
			queryParams += `${filteredEndDate ? `&before=${filteredEndDate.toISOString()}` : ''}`
      queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;
      queryParams += `${filteredSources && filteredSources.length > 0 ? '&sources=' + filterObjectToQuery(filteredSources) : ''}`
      queryParams += `${filteredDoneInDelay ? '&doneInDelay=true' : ''}`

			API.get('/services/export' + queryParams, {
				cancelToken: new CancelToken(function executor(c) {
					fetchServicesExport_cancel = c;
				})
			})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					toastr.error('Erro', err)
					reject(err);
				});
		})
  };
};

export const fetchMoreServicesByEquipmentStart = () => ({
  type: actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_START,
});

export const fetchMoreServicesByEquipmentSuccess = (services) => ({
  type: actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_SUCCESS,
  services,
});

export const fetchMoreServicesByEquipmentFail = (error) => ({
  type: actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_FAIL,
  error,
});

// Lista infinita: a página 1 substitui a lista (novo filtro), páginas seguintes (shouldFetchMoreData) fazem append.
export const fetchServicesByEquipment = (id, page, limit, order, orderBy, equipmentServices = [], shouldFetchMoreData = false) => {
  fetchServicesByEquipment_cancel && fetchServicesByEquipment_cancel()

  return dispatch => {
    if (shouldFetchMoreData) {
      dispatch(fetchMoreServicesByEquipmentStart());
    } else {
      dispatch(requestServicesStart());
    }
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `${equipmentServices && equipmentServices.length > 0 ? `&equipment_services=${equipmentServices.join(',')}` : ''}`;
    API.get(`/services/equipment/${id}${queryParams}`, {
      cancelToken: new CancelToken(function executor(c) {
        fetchServicesByEquipment_cancel = c;
      })
    })
      .then(res => {
        if (shouldFetchMoreData) {
          dispatch(fetchMoreServicesByEquipmentSuccess(res.data));
        } else {
          dispatch(fetchServicesByEquipmentSuccess(res.data));
        }
      })
      .catch(err => {
        if (axios.isCancel(err)) return;
        if (shouldFetchMoreData) {
          dispatch(fetchMoreServicesByEquipmentFail(err));
        } else {
          dispatch(requestServicesFail(err));
        }
      });
  };
};

export const fetchServicesById = (id) => {
  fetchServicesById_cancel && fetchServicesById_cancel()

  return dispatch => {
    dispatch(requestServicesStart());
    API.get('/services/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchServicesById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchCompanyByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestServicesFail(err));
      });
  };
};

export const deleteServices = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServicesStart());
      API.put('/services/' + index + '/delete')
        .then(res => {
          dispatch(deleteServicesSuccess(res.data));
          toastr.success(i18n.t('deleteServices.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const postServices = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestServicesStart());
      API.post('/services', body)
        .then(res => {
          dispatch(postServicesSuccess(res.data));
          toastr.success(i18n.t('postServices.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postServices.toastrError'), i18n.t('postServices.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateServices = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestServicesStart());
      API.put('/services/' + index, body)
        .then(res => {
          dispatch(updateServicesSuccess(res.data));
          toastr.success(i18n.t('updateServices.toastr'));
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateServices.toastrError'), i18n.t('updateServices.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const checkDeleteServices = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServicesStart());
      API.get('/services/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteDocumentServicesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          resolve('error');
        });
    })
  }
}

export const postAddDocumentServices = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServicesStart());
      API.post('/services/' + index + '/adddocument', body)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('postAddDocumentServices.toastr'), i18n.t('postAddDocumentServices.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const updateAddDocumentServices = (index, body, documentId) => {

  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServicesStart());
      API.put('/services/' + index + '/adddocument/' + documentId, body)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('updateAddDocumentServices.toastr'),i18n.t('updateAddDocumentServices.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const deleteAddDocumentServices = (index, documentId) =>
  dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServicesStart());
      API.delete('/services/' + index + '/adddocument/' + documentId)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('deleteAddDocumentServices.toastr'), i18n.t('deleteAddDocumentServices.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }


const fetchEquipmentsStart = () => {
  return {
    type: actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_START
  };
};

const fetchEquipmentsSuccess = (equipments) => {
  return {
    type: actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_SUCCESS,
    payload: equipments,
  };
};

const fetchEquipmentsFail = () => {
  return {
    type: actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_FAIL,
  };
};


export const servicesTableFiltersFetchEquipments = (page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies) => {
  return (dispatch) => {
    dispatch(fetchEquipmentsStart());
    fetchEquipmentsService(page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, false, false)
      .then((res) => {
        dispatch(fetchEquipmentsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchEquipmentsFail());
      });
  };
};

export const servicesTableFiltersSetSelectedEquipment = (equipment) => {
  return {
    type: actionTypes.FILTER_SERVICE_EQUIPMENT,
    payload: equipment,
  };
}
